'use client'
import * as React from 'react'
import { tw } from 'utils/classnames'
import { useUserQuery } from 'auth/hooks'
import { useLocale, useTranslations } from 'next-intl'
import { NEXT_PUBLIC_CF_URL } from '@web/utils/env'
import { addOrReplaceLocaleInUrl } from 'cf-i18n/helpers'

import { ProductShareTitle } from './title'
import { UrlShare } from './url'
import { SocialShareOptions } from './social-share'
import { useProductDataQuery } from '@web/hooks/use-product-data'

type ContainerProsp = React.HTMLAttributes<HTMLDivElement>

export function Container({ className, ...rest }: ContainerProsp) {
  const locale = useLocale()
  const { data: productContent } = useProductDataQuery()
  const t = useTranslations('prod.product_description_page.share_earn')
  const { data } = useUserQuery(undefined, {
    select: data => {
      return {
        affiliateId: data.me?.user?.affiliateInfo?.affiliateId,
        userId: data.me?.user?.id,
      }
    },
  })
  const affiliateId = data?.affiliateId
  const id = productContent?.id
  const slug = productContent?.slug

  // Hide section for users without an affiliate ID.
  if (!affiliateId) {
    return null
  }

  const link = addOrReplaceLocaleInUrl(
    `${NEXT_PUBLIC_CF_URL}/prod/${slug}-${id}/ref/${affiliateId}/?sharedfrom=pdp`,
    locale,
  )

  return (
    <div
      data-id="prod-share-earn"
      className={tw(
        'rounded-4 bg-cf-white relative flex w-full flex-col justify-center border border-[#DFDDE5] px-4 py-6',
        className,
      )}
      {...rest}
    >
      <ProductShareTitle />
      <UrlShare className="mb-4" link={link} buttonLabel={t('copy')} copiedLabel={t('copied')} />
      <SocialShareOptions className="mb-4" />
    </div>
  )
}
